<template>
  <div class="addNewClass">
    <div class="content">
      <el-row :gutter="40">
        <el-col :span="4">
          <div class="grid-content bg-purple name">
            <span>活动名称</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="20">
          <div class="grid-content bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="10">
                <div class="flex">
                  <el-input
                    v-model="form.name"
                    placeholder="请输入活动名称"
                    size="small"
                    class="marginR"
                  ></el-input>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="4">
          <div class="grid-content bg-purple name">
            <span>活动内容</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="20">
          <div class="grid-content bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="10">
                <div class="flex">
                  <el-input
                    type="textarea"
                    v-model="form.des"
                    placeholder="请输入内容"
                    size="small"
                  ></el-input>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="4">
          <div class="grid-content bg-purple name">
            <span>活动时间</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="19">
          <el-date-picker
            size="mini"
            v-model="getTime"
            type="datetimerange"
            value-format="yyyy-M-d"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="4">
          <div class="grid-content bg-purple name">
            <span>活动海报</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="20">
          <div class="grid-content bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="10">
                <el-upload
                  name="image"
                  :data="imgdata"
                  class="avatar-uploader marginRL"
                  :show-file-list="false"
                  accept="image/jpeg,image/gif,image/png"
                  action="https://www.58zltc.com/api/Upload/uploads/"
                  :on-success="handleLogoSuccess"
                  :before-upload="beforeLogoUpload"
                >
                  <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="4">
          <div class=" bg-purple name">
            <span>开启报名</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="20">
          <el-switch
            v-model="checkStatus"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="4">
          <div class=" bg-purple name">
            <span>开启报名审核</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="20">
          <el-switch
            v-model="checkAuth"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="4">
          <div class="grid-content bg-purple name">
            <span>可参与商家数</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="20">
          <div class="grid-content bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="10">
                <input
                  v-model="form.num"
                  placeholder="请输入数量"
                  size="small"
                  type="number"
                  oninput="if(value  <= 0 ){value = 0}"
                  class="marginR radioInput"
                />人
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="4">
          <div class="grid-content bg-purple name">
            <span>可参与商品数</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="grid-content bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="10">
                <input
                  v-model="form.num"
                  placeholder="请输入数量"
                  size="small"
                  type="number"
                  oninput="if(value  <= 0 ){value = 0}"
                  class="marginR radioInput"
                />个
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="4">
          <div class="grid-content bg-purple name">
            <span>活动设置</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="marginSX">
            <el-radio-group v-model="form.full_type" @change="changeStatus">
              <el-radio label="1">满N元促销活动</el-radio>
              <el-radio label="2">满N件促销活动</el-radio>
            </el-radio-group>
          </div>
          <div class="marginSX">
            <el-radio v-model="form.type" label="1">
              阶梯满减
            </el-radio>
          </div>
          <!-- 满减 -->
          <div class="box" v-for="(item, index) in numRules" :key="index">
            <div class="flex">
              <div style="padding:5px 10px 5px 28px;">优惠门槛:</div>
              <div style="height:28px;" v-if="form.full_type == 1">
                满<input
                  class="radioInput"
                  type="number"
                  v-model="item.total_money"
                  oninput="if(value  <= 0 ){value = 0}"
                />元
              </div>
              <div style="height:28px;" v-else>
                满<input
                  class="radioInput"
                  type="number"
                  v-model="item.total_num"
                  oninput="if(value  <= 0 ){value = 0}"
                />件
              </div>
            </div>
            <div class="flex marginSX">
              <div style="padding:5px 10px 5px 28px;">优惠内容:</div>
              <div class="">
                <el-checkbox v-model="orderStatus">订单金额优惠</el-checkbox>
                <div style="padding-left: 20px;">
                  <div class="marginSX" v-if="form.full_type == '1'">
                    <el-radio v-model="orderLabel" label="1">
                      减<input
                        class="radioInput"
                        type="number"
                        v-model="item.dec_price"
                        oninput="if(value  <= 0 ){value = 0}"
                      />元
                    </el-radio>
                  </div>
                  <div class="marginSX" v-if="form.full_type == '2'">
                    <el-radio v-model="orderLabel" label="2">
                      减<input
                        class="radioInput"
                        type="number"
                        v-model="item.free_num"
                        oninput="if(value  <= 0 ){value = 0}"
                      />件
                    </el-radio>
                  </div>
                  <div
                    class="marginSX"
                    style="padding-left: 20px;"
                    v-show="orderLabel == '2' && form.full_type == '2'"
                  >
                    <el-radio v-model="item.payment_status" label="1"
                      >按最高商品价格</el-radio
                    >
                    <el-radio v-model="item.payment_status" label="2"
                      >按最低商品价格</el-radio
                    >
                  </div>
                  <div style="height:28px;">
                    <el-radio v-model="orderLabel" label="3">
                      打<input
                        class="radioInput"
                        type="number"
                        v-model="item.zhe_num"
                        oninput="if(value  <= 0 ){value = 0}"
                      />折
                    </el-radio>
                    <!--  v-if="fullType== '2'" -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-button type="text" @click="addRules(1)">新增条件</el-button>
          <el-button type="text" @click="addRules(0)">减少条件</el-button>
        </el-col>
      </el-row>

      <el-row :gutter="20" justify="end" type="flex" style="margin-bottom:40px">
        <el-col :span="4">
          <el-button type="primary" @click="submit">
            <span>提交</span>
          </el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { addactive, editactive, detailactive } from "@/api/active";
export default {
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"])
  },
  components: {},
  data() {
    return {
      numRules: [
        {
          dec_price_status: "0",
          total_money: "0",
          dec_price: "0",
          // 件
          free_status: "0",
          total_num: "0",
          free_num: "0",
          // 折
          zhe_status: "0",
          zhe_num: "0",
          // 最低/高价
          payment_status: "1"
        }
      ],
      jude: 0,
      checkStatus: true,
      checkAuth: true,
      getTime: [],
      orderStatus: true,
      orderLabel: "1",
      imgdata: {},
      imageUrl: "",
      imageIdx: 0,
      form: {
        name: "",
        des: "",
        set_status: "1",
        is_auth: "1",
        is_cover: "0",
        cover: "", //图片id
        num: "",
        type: "1", //阶梯满减
        full_type: "1",
        discount_status: "1",
        // 钱
        dec_price_status: "1",
        total_money: "0",
        dec_price: "0",
        // 件
        free_status: "0",
        total_num: "0",
        free_num: "0",
        // 折
        zhe_status: "0",
        zhe_num: "0",

        // 高低
        payment_status: "1",
        start_time: "",
        end_time: ""
      }
    };
  },
  mounted() {
    this.imgdata = {
      app_id: this.app_id,
      token: this.token,
      type: "1",
      file_group: "1"
    };
    if (this.$route.query.idE) {
      this.jude = this.$route.query.idE;
      this.details_disabled = true;
      this.getDetail();
    }
  },
  methods: {
    // 新增条件
    addRules(type) {
      if (type == 1) {
        var obj = {
          dec_price_status: "0",
          total_money: "0",
          dec_price: "0",
          // 件
          free_status: "0",
          total_num: "0",
          free_num: "0",
          // 折
          zhe_status: "0",
          zhe_num: "0",
          // 最低/高价
          payment_status: "1"
        };
        this.numRules.push(obj);

        console.log("type", type);
      } else {
        this.numRules.pop();
        // console.log(this.numRules.pop());
      }
    },
    // changeStatus
    changeStatus(jude) {
      this.orderLabel = jude;
      var aa = typeof jude;
      console.log("状态", aa, jude, this.form.full_type);
    },
    handleLogoSuccess(res, file) {
      console.log(res);
      this.$message(res.msg);
      if (res.code == 200) {
        this.form.cover = res.data.id;
      }
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeLogoUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传Logo图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    // 获取编辑器内容
    changeeditor(value) {
      console.log("编辑内容", value);
      // this.form.textCon = value;
    },

    submit() {
      if (this.form.name == "") {
        this.$message("请填写活动名称");
        return false;
      }
      if (this.getTime.length == 0) {
        this.$message("请选择活动时间");
        return;
      } else {
        this.form.start_time = new Date(this.getTime[0]).getTime() / 1000;
        this.form.end_time = new Date(this.getTime[1]).getTime() / 1000;
      }

      if (this.form.is_cover == 1) {
        this.imageUrl = this.form.cover_url;
      }
      //  是否开启活动
      this.form.set_status = this.checkStatus == true ? 1 : 0;
      //  是否开启活动审核
      this.form.is_auth = this.checkAuth == true ? 1 : 0;
      // 优惠规则
      switch (this.orderLabel) {
        case "1":
          // if(this.form.dec_price == 0 || form.dec_price == ""){
          //   this.$message("");
          //   return false;
          // }
          this.form.dec_price_status = "1";
          break;
        case "2":
          this.form.free_status = "1";
          break;
        case "3":
          this.form.zhe_status = "1";
          break;
      }
      let data = {
        full_type: this.form.full_type,
        name: this.form.name,
        des: this.form.des,
        set_status: this.form.set_status,
        is_auth: this.form.is_auth,
        cover: this.form.cover,
        num: this.form.num,
        type: this.form.type,
        dec_price_status: this.form.dec_price_status,
        total_money: this.form.total_money,
        dec_price: this.form.dec_price,
        free_status: this.form.free_status,
        total_num: this.form.total_num,
        free_num: this.form.free_num,
        zhe_status: this.form.zhe_status,
        zhe_num: this.form.zhe_num,
        payment_status: this.form.payment_status,
        start_time: this.form.start_time, //
        end_time: this.form.end_time, //
        token: this.token,
        app_id: this.app_id
      };
      console.log("提交数据", data);
      // return false;
      if (this.jude == 0) {
        addactive(data).then(res => {
          console.log("保存活动", res);

          if (res.code == 400) {
            this.$message({
              message: res.msg,
              type: "warning"
            });
          } else {
            this.$message({
              message: res.msg,
              type: "success"
            });
            this.$router.go(-1);
          }
        });
      } else {
        data.id = this.jude;
        editactive(data).then(res => {
          console.log("编辑提交", res);
          if (res.code == 0) {
            this.$message({
              message: res.msg,
              type: "warning"
            });
          } else {
            this.$message({
              message: res.msg,
              type: "success"
            });
            this.$router.go(-1);
          }
        });
      }
    },
    // 商品详情
    getDetail() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        id: this.jude
      };
      detailactive(data).then(res => {
        if (res.code == 200) {
          this.form = res.data;
          this.getTime = [];
          this.getTime.push(this.form.start_time);
          this.getTime.push(this.form.end_time);
          this.imageUrl = this.form.cover_url;
          //  是否开启活动
          this.checkStatus = this.form.set_status == 1 ? true : false;
          //  是否开启活动审核
          this.checkAuth = this.form.is_auth == 1 ? true : false;
          // 优惠
          if (this.form.dec_price_status == 1) {
            this.orderLabel == "1";
          }
          if (this.form.free_status == 1) {
            this.orderLabel == "2";
          }
          if (this.form.zhe_status == 1) {
            this.orderLabel == "3";
          }
          this.form.full_type = String(this.form.full_type);

          //活动商品

          this.form.activity_type = String(this.form.activity_type);
          //默认文案
          this.form.is_cover = String(this.form.is_cover);
          // 阶梯满减
          this.form.payment_status = String(this.form.payment_status);
          // 阶梯满减
          this.form.type = String(this.form.type);
          console.log("xiangq ", this.getTime);
        }
        console.log("活动详情", res);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  justify-content: flex-start;
}
.color {
  color: #606266;
  font-size: 10px;
}

.radioInput {
  height: 28px;
  margin: 0 5px;
  width: 100px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
}
.radioInputM {
  height: 28px;
  margin-right: 5px;
  width: 60px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
}
.marginR {
  margin-right: 5px;
}
.marginRL {
  margin: 0 5px;
}
.marginSX {
  margin: 10px 0;
}
.avatar-uploader .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px solid #dcdfe6;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.addNewClass {
  height: 100%;
  position: relative;
  .content {
    position: absolute;
    overflow: auto;
    top: 0px;
    bottom: 26px;
    left: 22px;
    right: 70px;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    padding: 20px 30px;
    .operation {
      height: 50px;
    }
    .el-row {
      margin-top: 15px;
      font-size: 14px;
    }
    .grid-content {
      line-height: 36px;
      min-height: 36px;
      font-size: 14px;
      .label {
        // width: 70px;
        line-height: 20px;
        // height: 20px;
        padding: 5px 15px;
        border-radius: 20px;
        background: rgba(64, 158, 255, 0.1);
        text-align: center;
        margin-right: 10px;
        position: relative;
        .close {
          width: 15px;
          height: 15px;
          border-radius: 50%;
          background: #ff00004f;
          line-height: 15px;
          position: absolute;
          right: 0;
          top: -5px;
        }
      }
    }
    .labelsort {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .name {
      text-align: right;
    }
    .rgt {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }
  .img {
    width: 80px;
    height: 80px;
    background: #ff00004f;
  }
}
</style>

<style lang="scss">
.addNewClass {
  .editor {
    width: 100%;
    .text {
      min-height: 220px;
    }
  }
}
</style>
